/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'entrust': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h20v20H0z"/><g _fill="currentColor" fill-rule="nonzero"><path pid="1" d="M16.4 18H3.6A1.6 1.6 0 012 16.4V3.6A1.6 1.6 0 013.6 2h12.8A1.6 1.6 0 0118 3.6v12.8a1.6 1.6 0 01-1.6 1.6zm.4-14.4a.4.4 0 00-.4-.4H3.6a.4.4 0 00-.4.4v12.8a.4.4 0 00.4.4h12.8a.4.4 0 00.4-.4V3.6zm-2.2 10h-4a.6.6 0 010-1.2h4a.6.6 0 110 1.2zm0-6h-4a.6.6 0 110-1.2h4a.6.6 0 010 1.2zm-8 7.2a1.8 1.8 0 110-3.6 1.8 1.8 0 010 3.6zm0-2.4a.6.6 0 100 1.2.6.6 0 000-1.2z"/><path pid="2" d="M8.606 6.447L6.881 8.18a.608.608 0 01-.863 0l-.862-.866a.615.615 0 01.431-1.047c.162 0 .317.065.431.18l.432.433 1.294-1.3a.608.608 0 01.862 0 .615.615 0 010 .867z"/></g></g>'
  }
})
